import { gql, HttpLink, ApolloLink, ApolloClient, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject;
var USER_UPDATE_PASSWORD_MUTATION = /*#__PURE__*/gql(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation appUserUpdatePassword($uuid: String!, $password: String!) {\n    appUserUpdatePassword(uuid: $uuid, password: $password)\n  }\n"])));

var _templateObject$1, _templateObject2, _templateObject3;
var LOGIN_MUTATION = /*#__PURE__*/gql(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation login($data: LoginInput!) {\n    login(data: $data) {\n      id\n      uuid\n      token\n      refresh_token\n      token_expires\n      refresh_token_expires\n      time\n      timezone\n    }\n  }\n"])));
var LOGOUT_MUTATION = /*#__PURE__*/gql(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation {\n    logout\n  }\n"])));
var REFRESH_TOKEN_MUTATION = /*#__PURE__*/gql(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation refreshToken($refresh_token: String!) {\n    refreshToken(refresh_token: $refresh_token) {\n      token\n    }\n  }\n"])));

var _templateObject$2, _templateObject2$1;
var REGISTER_MUTATTION = /*#__PURE__*/gql(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation register($data: RegisterInput!) {\n    register(data: $data) {\n      user{\n        id,\n        displayname,\n        uuid\n      }\n      token{\n        token\n        refresh_token\n        token_expires\n        refresh_token_expires\n        time\n        timezone\n      }\n    }\n  }\n"])));
var FORGOT_PASSWORD_MUTATION = /*#__PURE__*/gql(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation forgotPassword($data: ForgotPasswordInput!){\n    forgotPassword(data: $data)\n  }\n"])));

var _templateObject$3, _templateObject2$2, _templateObject3$1, _templateObject4;
var SET_CUSTOM_FIELD = /*#__PURE__*/gql(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation setCustomField($input: CustomFieldInput!) {\n    setCustomField(input: $input)   \n  }\n"])));
var GET_CUSTOM_FIELD = /*#__PURE__*/gql(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation getCustomField($input: CustomFieldInput!) {\n    getCustomField(input: $input)   \n  }\n"])));
var GET_ALL_CUSTOM_FIELDS = /*#__PURE__*/gql(_templateObject3$1 || (_templateObject3$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation getAllCustomField($input: CustomFieldInput!) {\n    getAllCustomField(input: $input)   \n  }\n"])));
var DELETE_CUSTOM_FIELD = /*#__PURE__*/gql(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  mutation deleteCustomField($input: CustomFieldInput!) {\n    deleteCustomField(input: $input)   \n  }\n"])));

var _templateObject$4;
var APP_USERS_QUERY = /*#__PURE__*/gql(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  query filterUser($first: Int, $where: QueryAppUsersWhereWhereConditions) {\n    appUsers(first: $first, where: $where) {\n      data {\n        id\n        uuid\n        email\n        displayname\n        lastname\n        firstname\n        sex\n        description\n        user_active\n        address {\n          address_1\n          address_2\n          city {\n            id\n            name\n            latitude\n            longitude\n            states_id\n            countries_id\n          }\n          country {\n            id\n            name\n            code\n            flag\n          }\n          zip_code\n          state {\n            id\n            code\n            name\n          }\n        }\n        contact {\n          phone_number\n          cell_phone_number\n        }\n        companies {\n          id\n          uuid\n          name\n        }\n        branches {\n          id\n          name\n          companies_id\n        }\n        created_at\n        updated_at\n      }\n      paginatorInfo {\n        currentPage\n        lastPage\n      }\n    }\n  }\n"])));

var _templateObject$5, _templateObject2$3;
var AppSettingsQuery = /*#__PURE__*/gql(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  query getAppSettings($appKey: String!) {\n    getAppSettings(key: $appKey) {\n      name,\n      settings\n    }\n  }\n"])));
var CompanySettingsQuery = /*#__PURE__*/gql(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  query getCompanySettings {\n    companySettings {\n      name,\n      settings\n    }\n  }\n"])));

var _templateObject$6, _templateObject2$4;
var COUNTRIES_QUERY = /*#__PURE__*/gql(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  query {\n    countries(first: 250, orderBy: [{ column: ID, order: ASC }]) {\n      data {\n        id\n        name\n        code\n      }\n      paginatorInfo {\n        currentPage\n        lastPage\n      }\n    }\n  }\n"])));
var GET_STATES_BY_COUNTRY_QUERY = /*#__PURE__*/gql(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  query GetStatesByCountry(\n    $first: Int!\n    $where: QueryCountriesWhereWhereConditions\n  ) {\n    countries(first: $first, where: $where) {\n      data {\n        id\n        states {\n          id\n          name\n          code\n          cities {\n            name\n            countries_id\n          }\n        }\n      }\n    }\n  }\n"])));

var Users = /*#__PURE__*/function () {
  function Users(client) {
    this.client = client;
  }
  /**
   * Update user password as admin
   * @param uuid user uuid
   * @param password user password
   * @returns AppUpdatePasswordInterface object with a boolean value if the password was updated
   * @throws Error when adminKey or x-kanvas-key header is not provided in KanvasCore options
   * */
  var _proto = Users.prototype;
  _proto.updatePassword =
  /*#__PURE__*/
  function () {
    var _updatePassword = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(uuid, password) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.client.mutate({
              mutation: USER_UPDATE_PASSWORD_MUTATION,
              variables: {
                uuid: uuid,
                password: password
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function updatePassword(_x, _x2) {
      return _updatePassword.apply(this, arguments);
    }
    return updatePassword;
  }()
  /**
   * Get user by email
   * @param email user email address
   * @returns AppUserInterface object which contains the user data
   * @throws Error when adminKey or x-kanvas-key header is not provided in KanvasCore options
   * */
  ;
  _proto.getUserByEmail =
  /*#__PURE__*/
  function () {
    var _getUserByEmail = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(email) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.client.query({
              query: APP_USERS_QUERY,
              variables: {
                first: 1,
                where: {
                  column: 'EMAIL',
                  operator: 'EQ',
                  value: email
                }
              }
            });
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data.appUsers.data[0]);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getUserByEmail(_x3) {
      return _getUserByEmail.apply(this, arguments);
    }
    return getUserByEmail;
  }();
  return Users;
}();
var App = function App(client) {
  this.client = client;
  this.users = new Users(this.client);
};

var Auth = /*#__PURE__*/function () {
  function Auth(client) {
    this.client = client;
  }
  var _proto = Auth.prototype;
  _proto.login = /*#__PURE__*/function () {
    var _login = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(email, password) {
      var data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = {
              email: email,
              password: password
            };
            _context.next = 3;
            return this.client.mutate({
              mutation: LOGIN_MUTATION,
              variables: {
                data: data
              }
            });
          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data.login);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function login(_x, _x2) {
      return _login.apply(this, arguments);
    }
    return login;
  }();
  _proto.logout = /*#__PURE__*/function () {
    var _logout = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.client.mutate({
              mutation: LOGOUT_MUTATION
            });
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function logout() {
      return _logout.apply(this, arguments);
    }
    return logout;
  }();
  _proto.refreshToken = /*#__PURE__*/function () {
    var _refreshToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(token) {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.client.mutate({
              mutation: REFRESH_TOKEN_MUTATION,
              variables: {
                refresh_token: token
              }
            });
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function refreshToken(_x3) {
      return _refreshToken.apply(this, arguments);
    }
    return refreshToken;
  }();
  return Auth;
}();

var Users$1 = /*#__PURE__*/function () {
  function Users(client) {
    this.client = client;
  }
  var _proto = Users.prototype;
  _proto.register = /*#__PURE__*/function () {
    var _register = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(userData) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.client.mutate({
              mutation: REGISTER_MUTATTION,
              variables: {
                data: userData
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function register(_x) {
      return _register.apply(this, arguments);
    }
    return register;
  }();
  _proto.forgotPassword = /*#__PURE__*/function () {
    var _forgotPassword = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(email) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.client.mutate({
              mutation: FORGOT_PASSWORD_MUTATION,
              variables: {
                data: {
                  email: email
                }
              }
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function forgotPassword(_x2) {
      return _forgotPassword.apply(this, arguments);
    }
    return forgotPassword;
  }();
  return Users;
}();

var CustomFields = /*#__PURE__*/function () {
  function CustomFields(client) {
    this.client = client;
  }
  var _proto = CustomFields.prototype;
  _proto.setCustomField = /*#__PURE__*/function () {
    var _setCustomField = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.client.mutate({
              mutation: SET_CUSTOM_FIELD,
              variables: {
                input: data
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function setCustomField(_x) {
      return _setCustomField.apply(this, arguments);
    }
    return setCustomField;
  }();
  _proto.getCustomField = /*#__PURE__*/function () {
    var _getCustomField = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.client.mutate({
              mutation: GET_CUSTOM_FIELD,
              variables: {
                input: data
              }
            });
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getCustomField(_x2) {
      return _getCustomField.apply(this, arguments);
    }
    return getCustomField;
  }();
  _proto.getAllCustomFields = /*#__PURE__*/function () {
    var _getAllCustomFields = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.client.mutate({
              mutation: GET_ALL_CUSTOM_FIELDS,
              variables: {
                input: data
              }
            });
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function getAllCustomFields(_x3) {
      return _getAllCustomFields.apply(this, arguments);
    }
    return getAllCustomFields;
  }();
  _proto.deleteCustomField = /*#__PURE__*/function () {
    var _deleteCustomField = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data) {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.client.mutate({
              mutation: DELETE_CUSTOM_FIELD,
              variables: {
                input: data
              }
            });
          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function deleteCustomField(_x4) {
      return _deleteCustomField.apply(this, arguments);
    }
    return deleteCustomField;
  }();
  return CustomFields;
}();

var Locations = /*#__PURE__*/function () {
  function Locations(client) {
    this.client = client;
  }
  var _proto = Locations.prototype;
  _proto.getAllCountries = /*#__PURE__*/function () {
    var _getAllCountries = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.client.query({
              query: COUNTRIES_QUERY
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getAllCountries() {
      return _getAllCountries.apply(this, arguments);
    }
    return getAllCountries;
  }();
  _proto.getStatesByCountry = /*#__PURE__*/function () {
    var _getStatesByCountry = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.client.query({
              query: GET_STATES_BY_COUNTRY_QUERY,
              variables: {
                first: 100,
                where: {
                  column: 'ID',
                  operator: 'EQ',
                  value: id
                }
              }
            });
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data.countries);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getStatesByCountry(_x) {
      return _getStatesByCountry.apply(this, arguments);
    }
    return getStatesByCountry;
  }();
  return Locations;
}();

var Settings = /*#__PURE__*/function () {
  function Settings(client, key) {
    this.client = client;
    this.key = key;
  }
  var _proto = Settings.prototype;
  _proto.getAppSettings = /*#__PURE__*/function () {
    var _getAppSettings = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$this$client$qu, _getAppSettings2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return this.client.query({
              query: AppSettingsQuery,
              variables: {
                appKey: this.key
              },
              fetchPolicy: 'no-cache'
            });
          case 3:
            _yield$this$client$qu = _context.sent;
            _getAppSettings2 = _yield$this$client$qu.data.getAppSettings;
            return _context.abrupt("return", _getAppSettings2);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", undefined);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[0, 8]]);
    }));
    function getAppSettings() {
      return _getAppSettings.apply(this, arguments);
    }
    return getAppSettings;
  }();
  _proto.getCompanySettings = /*#__PURE__*/function () {
    var _getCompanySettings = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$this$client$qu2, companySettings;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return this.client.query({
              query: CompanySettingsQuery,
              fetchPolicy: 'no-cache'
            });
          case 3:
            _yield$this$client$qu2 = _context2.sent;
            companySettings = _yield$this$client$qu2.data.companySettings;
            return _context2.abrupt("return", companySettings);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", undefined);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[0, 8]]);
    }));
    function getCompanySettings() {
      return _getCompanySettings.apply(this, arguments);
    }
    return getCompanySettings;
  }();
  return Settings;
}();

function genericAuthMiddleware(fn) {
  return setContext( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, context) {
      var key, headers;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fn();
          case 2:
            key = _context.sent;
            headers = _extends({}, context.headers, {
              'Authorization': key ? "Bearer " + key : ''
            });
            return _context.abrupt("return", {
              headers: headers
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
var KanvasCore = /*#__PURE__*/function () {
  function KanvasCore(options) {
    this.options = options;
    this.client = new ApolloClient({
      link: this.generateLink(),
      cache: new InMemoryCache()
    });
    this.app = new App(this.client);
    this.auth = new Auth(this.client);
    this.users = new Users$1(this.client);
    this.customFields = new CustomFields(this.client);
    this.settings = new Settings(this.client, this.options.key);
    this.locations = new Locations(this.client);
  }
  var _proto = KanvasCore.prototype;
  _proto.generateURL = function generateURL() {
    return new HttpLink({
      uri: this.options.url
    });
  };
  _proto.generateMiddleware = function generateMiddleware() {
    var _this = this;
    return setContext( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_, context) {
        var headers;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              headers = _extends({}, context.headers, {
                'X-Kanvas-App': _this.options.key
              }, _this.options.adminKey && {
                'X-Kanvas-Key': _this.options.adminKey
              });
              return _context2.abrupt("return", {
                headers: headers
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
  };
  _proto.generateLink = function generateLink() {
    return ApolloLink.from([].concat(this.options.middlewares || [], [this.generateMiddleware(), this.generateURL()]));
  };
  return KanvasCore;
}();

export default KanvasCore;
export { APP_USERS_QUERY, App, AppSettingsQuery, Auth, COUNTRIES_QUERY, CompanySettingsQuery, CustomFields, DELETE_CUSTOM_FIELD, FORGOT_PASSWORD_MUTATION, GET_ALL_CUSTOM_FIELDS, GET_CUSTOM_FIELD, GET_STATES_BY_COUNTRY_QUERY, LOGIN_MUTATION, LOGOUT_MUTATION, Locations, REFRESH_TOKEN_MUTATION, REGISTER_MUTATTION, SET_CUSTOM_FIELD, USER_UPDATE_PASSWORD_MUTATION, Users$1 as Users, genericAuthMiddleware };
//# sourceMappingURL=core.esm.js.map
